
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getRecievedOrdersRequest, getRecievedOrdersRequestError, getRecievedOrdersRequestSuccess } from "../../slices/Supplier/GetRecievedOrdersSlice";

export const GetRecievedOrdersApi = (data) => async (dispatch) => {

    const queryParams = new URLSearchParams(data).toString();

    const urlWithParams = `${endpoints.getSupplierOrders}?${queryParams}`;

    try {
        dispatch(getRecievedOrdersRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getRecievedOrdersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getRecievedOrdersRequestError(_error));
            });
    } catch (error) {
    }
};
